import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import Container from './style'

interface Props {
  symbol: ReactNode
  title: string
  children: ReactNode | string
  style?: CSSProperties
  className?: string
  id?: string
}

function Item({
  id,
  className,
  style,
  symbol,
  title,
  children,
}: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <figure className="symbol-container">{symbol}</figure>
      <article className="text-container">
        <h1>{title}</h1>
        <p>{children}</p>
      </article>
    </Container>
  )
}

Item.propTypes = {
  symbol: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
    .isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

Item.defaultProps = {
  className: '',
}

export default memo(Item)
